var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "tabs-container",
      on: { mouseenter: _vm.stopAutoPlay, mouseleave: _vm.handleMouseLeave },
    },
    [
      _c("div", { staticClass: "operation-module" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "tabs" },
          _vm._l(_vm.tabs, function (tab, index) {
            return _c(
              "span",
              {
                key: index,
                class: ["tab", { active: _vm.activeIndex === index }],
                on: {
                  click: function ($event) {
                    return _vm.changeTab(index)
                  },
                },
              },
              [_vm._v(" " + _vm._s(tab.name) + " ")]
            )
          }),
          0
        ),
      ]),
      _c(
        "div",
        { staticClass: "wrapper-100" },
        [
          _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
            _c(
              "div",
              { key: _vm.activeIndex, staticClass: "content-wrapper" },
              [
                _vm.currentContents.length
                  ? _c(
                      "div",
                      { staticClass: "cards-grid" },
                      _vm._l(_vm.currentContents, function (item, idx) {
                        return _c("div", { key: idx }, [
                          item.type === "paper"
                            ? _c(
                                "div",
                                {
                                  staticClass: "paper-content-card",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toPaperDetail(item.data.id)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "h4",
                                    {
                                      staticClass: "title",
                                      attrs: { title: item.data.title },
                                    },
                                    [_vm._v(_vm._s(item.data.title))]
                                  ),
                                  _c("p", { staticClass: "p2" }, [
                                    _vm._v(
                                      "出版物：" +
                                        _vm._s(item.data.venue || "-")
                                    ),
                                  ]),
                                  _c("div", { staticClass: "p3" }, [
                                    _c("p", [
                                      _vm._v(
                                        "摘要：" + _vm._s(item.data.abst || "-")
                                      ),
                                    ]),
                                  ]),
                                  _c("p", { staticClass: "p1" }, [
                                    _c("span", [
                                      _c("i", {
                                        staticClass: "el-icon-alarm-clock",
                                      }),
                                      _vm._v(
                                        "发表时间：" +
                                          _vm._s(
                                            item.data.date ||
                                              item.data.year ||
                                              "-"
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("span", [
                                      _vm._v(
                                        "引用：" +
                                          _vm._s(item.data.citationNum || "-")
                                      ),
                                    ]),
                                  ]),
                                ]
                              )
                            : item.type === "scholar"
                            ? _c(
                                "div",
                                {
                                  staticClass: "scholar-content-card",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toScholarDetail(item.data.id)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "inner" },
                                    [
                                      _c("el-avatar", {
                                        staticClass: "avatar",
                                        attrs: {
                                          size: 60,
                                          src: item.data.avatar,
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "scholar-infor" },
                                        [
                                          _c("div", { staticClass: "name" }, [
                                            _c("b", [
                                              _vm._v(_vm._s(item.data.name)),
                                            ]),
                                          ]),
                                          _c(
                                            "p",
                                            { staticClass: "common-class org" },
                                            [
                                              _vm._v(
                                                "所在机构：" +
                                                  _vm._s(
                                                    item.data.org_name || "-"
                                                  )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "common-class scholar-title",
                                            },
                                            [
                                              _c("label", [_vm._v("职称：")]),
                                              item.data.showTitle &&
                                              item.data.showTitle.length
                                                ? _c(
                                                    "p",
                                                    _vm._l(
                                                      item.data.showTitle,
                                                      function (tit, indx) {
                                                        return _c(
                                                          "span",
                                                          { key: indx },
                                                          [
                                                            _vm._v(
                                                              _vm._s(tit) + "；"
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _c("p", [_vm._v("-")]),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "common-class field",
                                            },
                                            [
                                              _c("label", [
                                                _vm._v("研究领域："),
                                              ]),
                                              item.data.fields &&
                                              item.data.fields.length
                                                ? _c(
                                                    "p",
                                                    _vm._l(
                                                      item.data.fields,
                                                      function (field, indx) {
                                                        return _c(
                                                          "span",
                                                          { key: indx },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                field.name
                                                              ) + "；"
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _c("p", [_vm._v("-")]),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "common-class count-number",
                                            },
                                            [
                                              _c("p", [
                                                _vm._v(
                                                  "成果数：" +
                                                    _vm._s(
                                                      item.data
                                                        .publications_count
                                                    )
                                                ),
                                              ]),
                                              _c("p", [
                                                _vm._v(
                                                  "引用数：" +
                                                    _vm._s(item.data.citedby)
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ])
                      }),
                      0
                    )
                  : _c("div", [_c("el-empty")], 1),
              ]
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", { staticClass: "recommend-title" }, [
      _c("span", [_vm._v("为您推荐")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }